<template>
  <transition name="q-lb-fade">
    <div v-if="visible" class="q-lightbox" @click.self="close">
      <button class="q-lb-close" @click="close" aria-label="Cerrar">✕</button>
      <button v-if="images.length > 1" class="q-lb-arrow q-lb-arrow--prev" @click.stop="prev" aria-label="Anterior">‹</button>
      <img :src="images[current]" class="q-lb-img" alt="" />
      <button v-if="images.length > 1" class="q-lb-arrow q-lb-arrow--next" @click.stop="next" aria-label="Siguiente">›</button>
      <div v-if="images.length > 1" class="q-lb-counter">{{ current + 1 }} / {{ images.length }}</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ImageLightbox",
  props: {
    images: { type: Array, default: () => [] },
    visible: { type: Boolean, default: false },
    start: { type: Number, default: 0 },
  },
  data() { return { current: 0 }; },
  watch: {
    visible(val) {
      if (val) {
        this.current = this.start;
        document.addEventListener("keydown", this.onKey);
        document.body.style.overflow = "hidden";
      } else {
        document.removeEventListener("keydown", this.onKey);
        document.body.style.overflow = "";
      }
    },
  },
  methods: {
    close() { this.$emit("close"); },
    next() { this.current = (this.current + 1) % this.images.length; },
    prev() { this.current = (this.current - 1 + this.images.length) % this.images.length; },
    onKey(e) {
      if (e.key === "Escape") this.close();
      else if (e.key === "ArrowRight") this.next();
      else if (e.key === "ArrowLeft") this.prev();
    },
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKey);
    document.body.style.overflow = "";
  },
};
</script>

<style scoped>
.q-lightbox {
  position: fixed; inset: 0; z-index: 1080;
  background: rgba(10, 12, 16, 0.92);
  display: flex; align-items: center; justify-content: center;
}
.q-lb-img { max-width: 90vw; max-height: 86vh; object-fit: contain; }
.q-lb-close {
  position: absolute; top: 18px; right: 22px;
  background: none; border: none; color: #fff; font-size: 26px; cursor: pointer; line-height: 1;
}
.q-lb-arrow {
  position: absolute; top: 50%; transform: translateY(-50%);
  background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2);
  color: #fff; width: 46px; height: 46px; border-radius: 50%;
  font-size: 26px; cursor: pointer; transition: background 0.2s ease;
}
.q-lb-arrow:hover { background: var(--primary-color); border-color: var(--primary-color); }
.q-lb-arrow--prev { left: 18px; }
.q-lb-arrow--next { right: 18px; }
.q-lb-counter {
  position: absolute; bottom: 22px; left: 50%; transform: translateX(-50%);
  color: #fff; font-family: var(--q-font-mono); font-size: 13px; opacity: 0.8;
}
.q-lb-fade-enter-active, .q-lb-fade-leave-active { transition: opacity 0.2s ease; }
.q-lb-fade-enter, .q-lb-fade-leave-to { opacity: 0; }
</style>
